import { createAction } from '@reduxjs/toolkit';
import { API, Cohort, CohortConfig, ErrorObject, User } from 'types';

export const fetchIndexHealthSample = createAction<void>('CUSTOMERS/FETCH_INDEX_HEALTH_SAMPLE');
export const fetchIndexHealthSampleRequest = createAction<void>(
  'CUSTOMERS/FETCH_INDEX_HEALTH_SAMPLE_REQUEST'
);
export const fetchIndexHealthSampleSuccess = createAction<API.Customers.IndexHealthSample>(
  'CUSTOMERS/FETCH_INDEX_HEALTH_SAMPLE_SUCCESS'
);
export const fetchIndexHealthSampleFailure = createAction<ErrorObject>(
  'CUSTOMERS/FETCH_INDEX_HEALTH_SAMPLE_FAILURE'
);

type SaveSOWUsersAndImportPayload = {
  users: User[];
  sow: Partial<Omit<Cohort, 'config'>> & { config: Partial<CohortConfig> };
  doO365Sweep: boolean;
  doTeamsweep: boolean;
};

export const saveSOWUsersAndImport = createAction<SaveSOWUsersAndImportPayload>(
  'CUSTOMERS/SAVE_SOW_USERS_AND_IMPORT'
);
export const saveSOWUsersAndImportRequest = createAction(
  'CUSTOMERS/SAVE_SOW_USERS_AND_IMPORT_REQUEST'
);
export const saveSOWUsersAndImportFailure = createAction<ErrorObject>(
  'CUSTOMERS/SAVE_SOW_USERS_AND_IMPORT_FAILURE'
);
export const saveSOWUsersAndImportSuccess = createAction(
  'CUSTOMERS/SAVE_SOW_USERS_AND_IMPORT_SUCCESS'
);
